import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as navigationActions from "../../../actions/navigationActions";
import * as componentTypes from "../../../constants/componentTypes";
import * as keyCodes from "../../../constants/keyCodes";

import imgClose from "../../../resources/img/svgicons/close-black.svg";
import Input from "../generic/Input";
import Button from "../generic/Button";

class FindPhraseModal extends Component {
    timer = null;

    constructor(props) {
        super(props);

        this.state = {
            searchPhrase: "",
            success: false,
            matchCase: true,
            style: "search-result"
        };
    }

    componentDidMount() {
        window.jQuery.expr[":"].containsCi = window.jQuery.expr.createPseudo(function (arg) {
            return function (elem) {
                return window.jQuery(elem).text().toLowerCase().indexOf(arg.toLowerCase()) >= 0;
            };
        });

        window.jQuery.expr[":"].containsCs = window.jQuery.expr.createPseudo(function (arg) {
            return function (elem) {
                return window.jQuery(elem).text().indexOf(arg) >= 0;
            };
        });
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.activeMenu !== prevProps.activeMenu ||
            this.props.activeMenuItem !== prevProps.activeMenuItem ||
            this.props.activeSubmenuItem !== prevProps.activeSubmenuItem ||
            this.props.activeSettingsMenuContent !== prevProps.activeSettingsMenuContent
        ) {
            setTimeout(() => {
                this.processSearching();
            }, 300);
        }
    }

    componentWillUnmount = () => {
        window.jQuery("." + this.state.style).removeClass(this.state.style);
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseFindPhraseModalAction();
    };

    searchInTab = (id, phrase) => {
        return window.jQuery("#tab-" + id + ":" + this.getContainsSelector() + "('" + phrase + "')").length > 0;
    };

    getContainsSelector = () => {
        if (!this.state.matchCase) {
            return "containsCi";
        }

        if (this.state.matchCase) {
            return "containsCs";
        }

        return "contains";
    };

    getAttrCaseModificator = () => {
        if (!this.state.matchCase) {
            return " i";
        }

        return "";
    };

    /**
     * @param {String | Object}     value
     */
    handleSearchWordChanged = (value) => {
        if (this.timer !== null) {
            clearTimeout(this.timer);
        }

        let phrase;
        if (typeof value === "string") {
            phrase = value;
        }
        if (typeof value === "object") {
            phrase = value.target.value;
        }

        this.setState({
            searchPhrase: phrase
        });

        this.timer = setTimeout(this.processSearching, 700);
    };

    processSearching = () => {
        window.jQuery("." + this.state.style).removeClass(this.state.style);
        let phrase = this.state.searchPhrase;
        let success = false;
        if (phrase.length > 3) {
            let translationTags = window.jQuery("span:" + this.getContainsSelector() + "('" + phrase.trim() + "')");
            if (translationTags.length > 0) {
                translationTags.addClass(this.state.style);
                success = true;
            }
            let checkboxLabels = window.jQuery("label:" + this.getContainsSelector() + "('" + phrase.trim() + "')");
            if (checkboxLabels.length > 0) {
                checkboxLabels.addClass(this.state.style);
                success = true;
            }
            let inputPlaceholders = window.jQuery(
                "input[placeholder*='" + phrase.trim() + "'" + this.getAttrCaseModificator() + "]"
            );
            if (inputPlaceholders.length > 0) {
                inputPlaceholders.addClass(this.state.style);
                success = true;
            }
            let sortableItems = window.jQuery(
                "ul.like-sortable-container li:" + this.getContainsSelector() + "('" + phrase.trim() + "')"
            );
            if (sortableItems.length > 0) {
                sortableItems.addClass(this.state.style);
                success = true;
            }
            let settingsSubTitle = window.jQuery(
                "h4.color-primary:" + this.getContainsSelector() + "('" + phrase.trim() + "')"
            );
            if (settingsSubTitle.length > 0) {
                settingsSubTitle.addClass(this.state.style);
                success = true;
            }
            let settingsTitle = window.jQuery(
                "h2.color-primary.uppercase:" + this.getContainsSelector() + "('" + phrase.trim() + "')"
            );
            if (settingsTitle.length > 0) {
                settingsTitle.addClass(this.state.style);
                success = true;
            }
            for (let tab of this.props.tabList) {
                if (this.searchInTab(tab.id, phrase.trim())) {
                    window.jQuery("li[data-id*='" + tab.id + "']").addClass(this.state.style);
                    success = true;
                }
            }
            let menu = window.jQuery(
                "li.dropdown.pull-right:" + this.getContainsSelector() + "('" + phrase.trim() + "')"
            );
            if (menu.length > 0) {
                menu.addClass(this.state.style);
                success = true;
            }
        }
        this.setState({
            success: success
        });
    };

    handleSearchKeyDown = (event) => {
        if (event.keyCode === keyCodes.ENTER) {
            this.processSearching();
        }
    };

    handleInputFocus = (event) => {
        event.target.select();
    };

    handleSearchSuccessful = () => {
        return (
            <span className={"margin-5 " + (this.state.success ? "color-green" : "color-red")}>
                {this.state.success ? "â" : "â"}
            </span>
        );
    };

    handleChangeCaseSensitivityClick = () => {
        this.setState({
            matchCase: !this.state.matchCase
        });

        setTimeout(() => {
            this.processSearching();
        }, 300);
    };

    handleChangeHighlightStyleClick = (event) => {
        window.jQuery("." + this.state.style).removeClass(this.state.style);
        this.setState({
            style: event.currentTarget.dataset.style
        });

        setTimeout(() => {
            this.processSearching();
        }, 300);
    };

    getCaseMatchButton = () => {
        return (
            <Button
                className={"margin-5 " + (this.state.matchCase ? "active" : "")}
                label={"Aa"}
                elementProps={{style: {fontSize: 15}}}
                onClick={this.handleChangeCaseSensitivityClick}
            />
        );
    };

    getHighlightStyleButton = () => {
        if (this.state.style === "search-result") {
            return (
                <Button
                    className="margin-5"
                    elementProps={{"data-style": "search-result-dark", style: {fontSize: 15}}}
                    label={<Translate value="keyWords.dark" />}
                    onClick={this.handleChangeHighlightStyleClick}
                />
            );
        }

        return (
            <Button
                className="margin-5"
                elementProps={{"data-style": "search-result", style: {fontSize: 15}}}
                onClick={this.handleChangeHighlightStyleClick}
                label={<Translate value="keyWords.light" />}
            />
        );
    };

    render() {
        return (
            <div id="modal" style={{WebkitAppRegion: "no-drag"}} className="find-text-modal default-modal">
                <Translate className="find-modal-title" value="findText.findTextTitle" />
                <Input
                    type="text"
                    className="primary-input margin-5"
                    value={this.state.searchPhrase}
                    onChange={this.handleSearchWordChanged}
                    onKeyDown={this.handleSearchKeyDown}
                    onFocus={this.handleInputFocus}
                    autoFocus={true}
                />
                {this.handleSearchSuccessful()}
                {this.getCaseMatchButton()}
                {this.getHighlightStyleButton()}
                <div className="modal-close" onClick={this.handleCloseModalClick}>
                    <img src={imgClose} className="close-img" alt="close" />
                </div>
            </div>
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        tabList: store.navigation.tabList,
        activeMenu: store.navigation.activeMenu,
        activeMenuItem: store.navigation.activeMenuItem,
        activeSubmenuItem: store.navigation.activeSubmenuItem,
        activeSettingsMenuContent: store.navigation.activeSettingsMenuContent
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseFindPhraseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.FIND_TEXT_MODAL));
        }
    };
};

export default FindPhraseModal = connect(mapStoreToProps, mapDispatchToProps)(FindPhraseModal);
